(function () {
  var header = document.querySelector('[data-site-header]');
  if (!header) return;

  var desktop = window.matchMedia('(min-width: 750px)');
  var toggles = Array.prototype.slice.call(header.querySelectorAll('[data-dropdown-toggle]'));
  var burger = header.querySelector('[data-nav-toggle]');

  function closeAllDropdowns(except) {
    header.querySelectorAll('[data-dropdown].is-open').forEach(function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var t = item.querySelector('[data-dropdown-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }

  // dropdown toggle (click/tap + keyboard); hover/focus is handled by CSS
  toggles.forEach(function (btn) {
    var item = btn.closest('[data-dropdown]');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var willOpen = !item.classList.contains('is-open');
      if (desktop.matches) closeAllDropdowns(item);
      item.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  // mobile menu
  function closeMobile() {
    header.classList.remove('nav-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    closeAllDropdowns(null);
  }
  function openMobile() {
    header.classList.add('nav-open');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  header.querySelectorAll('[data-nav-toggle]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (header.classList.contains('nav-open')) closeMobile();
      else openMobile();
    });
  });

  // close desktop dropdowns when clicking outside
  document.addEventListener('click', function (e) {
    if (desktop.matches && !header.contains(e.target)) closeAllDropdowns(null);
  });

  // Escape closes dropdowns / mobile menu
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllDropdowns(null);
    if (header.classList.contains('nav-open')) closeMobile();
  });

  // reset state when switching to desktop
  (desktop.addEventListener ? desktop.addEventListener('change', onChange) : desktop.addListener(onChange));
  function onChange() { if (desktop.matches) { closeMobile(); closeAllDropdowns(null); } }

  // Smart-sticky. Above the marquee's height the header is a normal in-flow
  // block. Past it, it is fixed to the top and the spacer takes over its
  // height (no jump: at that exact scroll position the two coincide). From
  // there it hides on the way down and returns on the first scroll up. The
  // 10px delta ignores jitter and iOS momentum wobble; the y <= threshold
  // branch also covers rubber-banding into negative scroll.
  var spacer = document.querySelector('[data-header-spacer]');
  var promoBar = document.querySelector('.promo-bar');
  var lastY = window.scrollY || window.pageYOffset || 0;
  var scrollTicking = false;
  var HIDE_DELTA = 10;

  function fixHeader(on) {
    if (header.classList.contains('is-fixed') === on) return;
    header.classList.toggle('is-fixed', on);
    if (spacer) spacer.hidden = !on;
  }

  function onHeaderScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    var threshold = promoBar ? promoBar.offsetHeight : 0;

    if (y <= threshold) {
      fixHeader(false);
      header.classList.remove('is-hidden');
      lastY = y;
      return;
    }

    fixHeader(true);

    var diff = y - lastY;
    if (Math.abs(diff) < HIDE_DELTA) return;
    lastY = y;

    if (header.classList.contains('nav-open')) {
      header.classList.remove('is-hidden');
      return;
    }
    header.classList.toggle('is-hidden', diff > 0);
  }

  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      onHeaderScroll();
    });
  }, { passive: true });

  onHeaderScroll();

  // --header-and-bar-height: promo bar + header height, consumed by the home
  // hero (85svh minus this). First set synchronously by the inline script in
  // header.liquid; kept in sync here on resize, promo text changes and theme
  // editor re-renders.
  var bar = document.querySelector('.promo-bar');
  function publishHeaderHeight() {
    var total = (bar ? bar.offsetHeight : 0) + header.offsetHeight;
    document.documentElement.style.setProperty('--header-and-bar-height', total + 'px');
  }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(publishHeaderHeight);
    ro.observe(header);
    if (bar) ro.observe(bar);
  } else {
    window.addEventListener('resize', publishHeaderHeight);
  }
  publishHeaderHeight();
  document.addEventListener('shopify:section:load', publishHeaderHeight);
})();
